module.exports = __webpack_public_path__ + "img/de_musset.2f7da29b.jpg";